import { openChatModal, openChatModalAfterAuth } from './openModal';
import { selectIsAuthenticated } from '../../selectors/user';
import { TChatModalOffer } from '../../types/chatModal';
import { TThunkAction } from '../../types/redux';

type TOnOpenChatArgs = {
  offer: TChatModalOffer;
  gaLabel: string;
  defaultMessage?: string;
};

export const onOpenChat = ({ offer, gaLabel, defaultMessage }: TOnOpenChatArgs): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { microfrontendsAPI } = context;
    const state = getState();
    const isUserAuthenticated = selectIsAuthenticated(state);

    if (isUserAuthenticated) {
      dispatch(openChatModal({ offer, gaLabel, defaultMessage }));
    } else if (microfrontendsAPI?.header) {
      dispatch(openChatModalAfterAuth({ offer, gaLabel, defaultMessage }));
      microfrontendsAPI.header.openAuthModal();
    }
  };
};
